import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
  Select,
  Toast,
  Spinner,
  Button,
  PageActions,
  DataTable,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import moment from "moment";
import { capitalizeFirstLetter } from "../../../Helpers";

const PackageSubscriberDetails = () => {
  const { id, subpackageId, subscriberId, pivot } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [result, setResult] = useState("");
  const [ts, setTs] = useState("");
  const [transactions, setTransactions] = useState(null);

  useEffect(() => {
    fetchData();
  }, [ts]);
  async function fetchData() {
    let responseItem = "";
    let responseTransactions = "";
    try {
      responseItem = await axios.get(
        `/packages/${id}/subpackages/${subpackageId}/subscribers/${subscriberId}/booking/${pivot}`
      );
      setResult(responseItem.data.data);
    } catch (error) {
      console.log(error);
    }
    // try {
    //   responseTransactions = await axios.get(`/app/users/${id}/logs`);
    //   responseTransactions.data.data &&
    //     responseTransactions.data.data.lenght &&
    //     setTransactions(
    //       responseTransactions.data.data.map((item, index) => [
    //         item?.event ? item?.event : "-",
    //         item?.description ? item?.description : "-",
    //         item?.created_at
    //           ? moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss")
    //           : "-",
    //       ])
    //     );
    // } catch (error) {
    //   console.log(error);
    // }
  }
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Amount has been added successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  const switchStatusColor = (param) => {
    switch (param) {
      case "pending":
        return `default`;
      case "confirmed":
        return `success`;
      case "cancelled":
        return `warning`;
      case "cancelled with charge":
        return `warning`;
      default:
        return "";
    }
  };
  return result ? (
    <Page
      narrowWidth
      backAction={{
        onAction: () =>
          navigate(
            `/admin/packages/${id}/subpackages/${subpackageId}/subscribers`
          ),
      }}
      title={`${result?.first_name ? result?.first_name : ""} ${
        result?.last_name ? result?.last_name : ""
      }`}
      titleMetadata={
        <Badge tone={switchStatusColor(result?.pivot?.status)}>
          {result?.pivot?.status}
        </Badge>
      }
    >
      <FormLayout>
        <Card>
          <FormLayout>
            <Text variant="headingSm" as="h6">
              SUBSCRIBER DETAILS
            </Text>
            <FormLayout.Group condensed>
              <Text breakWord>
                <b>First Name</b>
                <br /> {result?.first_name ? result?.first_name : "-"}
              </Text>
              <Text breakWord>
                <b>Last Name</b>
                <br /> {result?.last_name ? result?.last_name : "-"}
              </Text>
              <Text>
                <b>Email</b>
                <br /> {result?.email ? result?.email : "-"}
              </Text>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <Text breakWord>
                <b>Nationality</b>
                <br /> {result?.nationality ? result?.nationality : "-"}
              </Text>
              <Text breakWord>
                <b>Phone Number</b>
                <br /> {result?.phone_number ? result?.phone_number : "-"}
              </Text>
              <Text breakWord>
                <b>Created at</b>
                <br />
                {result?.pivot?.created_at
                  ? moment(result?.pivot?.created_at).format(
                      "YYYY-MM-DD HH:mm:ss"
                    )
                  : "-"}
              </Text>
            </FormLayout.Group>

            <FormLayout.Group condensed>
              <Text breakWord>
                <b>Is available?</b>
                <br /> {result?.pivot?.is_valid ? "Yes" : "No"}
              </Text>
              <Text breakWord>
                <b>Start Date</b>
                <br />
                {result?.pivot?.start_date ? result?.pivot?.start_date : "-"}
              </Text>
              <Text breakWord>
                <b>Expiry Date</b>
                <br />
                {result?.pivot?.expiry_date ? result?.pivot?.expiry_date : "-"}
              </Text>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <Text breakWord>
                <b>Bookings Count</b>
                <br />
                {result?.pivot && result?.pivot?.bookings_count !== null
                  ? result?.pivot?.bookings_count
                  : "-"}
              </Text>
              <Text breakWord>
                <b>Remaining Bookings</b>
                <br />
                {result?.pivot && result?.pivot?.remaining_bookings !== null
                  ? result?.pivot?.remaining_bookings
                  : "-"}
              </Text>
              <Text breakWord>
                <b>Payment Method</b>
                <br />
                {result?.pivot?.payment_type
                  ? capitalizeFirstLetter(result?.pivot?.payment_type)
                  : "-"}
              </Text>
            </FormLayout.Group>
          </FormLayout>
        </Card>
        {/* <Card>
          <FormLayout>
            <Text variant="headingSm" as="h6">
              TRANSACTIONS
            </Text>

            {transactions?.length ? (
              <DataTable
                columnContentTypes={["text", "text", "text", "text"]}
                headings={[
                  <Text variant="bodyMd" as="p" fontWeight="medium">
                    Event
                  </Text>,
                  <Text variant="bodyMd" as="p" fontWeight="medium">
                    Description
                  </Text>,
                  <Text variant="bodyMd" as="p" fontWeight="medium">
                    Created at
                  </Text>,
                ]}
                rows={transactions}
                verticalAlign="middle"
                increasedTableDensity
                // truncate
                // footerContent={
                //   pageObject.tableItems?.length &&
                //   `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
                // }
                hasZebraStripingOnData
              />
            ) : transactions !== null ? (
              <Text>No transactions found for this user</Text>
            ) : null}
          </FormLayout>
        </Card> */}
      </FormLayout>
      {/* <PageActions
        secondaryActions={
          <Button
            variant="primary"
            loading={isSaving}
            tone="critical"
            onClick={() => {
              setIsSaving(true);
              axios
                .delete(`/app/users/${id}`)
                .then((result) => {
                  navigate("/admin/users");
                })
                .catch((err) => console.log(err));
            }}
          >
            Delete
          </Button>
        }
      /> */}
      {toastMarkup}
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
};

export default PackageSubscriberDetails;
